import {
  ICreateSectionRequest,
  IUpdateDisplayNameRequest,
} from '../../types/api/request/productSectionSettingsRequest';
import {
  IGetAllSectionsResponse,
  IProductSection,
} from '../../types/api/response/productSectionSettingsResponse';
import axiosClient from '../axiosClient';
import { ProductSectionSettingsEndpoint } from '../endpoints/productSectionSettings';

export const ProductSectionSettingsService = {
  async getAllSections(): Promise<IGetAllSectionsResponse> {
    const res = await axiosClient.get<IGetAllSectionsResponse>(
      ProductSectionSettingsEndpoint.GET_ALL_SECTIONS,
    );
    return res.data;
  },

  async updateDisplayName(
    sectionName: string,
    payload: IUpdateDisplayNameRequest,
  ): Promise<IProductSection> {
    const res = await axiosClient.patch<IProductSection>(
      ProductSectionSettingsEndpoint.UPDATE_DISPLAY_NAME(sectionName),
      payload,
    );
    return res.data;
  },

  async toggleEnable(sectionName: string): Promise<IProductSection> {
    const res = await axiosClient.patch<IProductSection>(
      ProductSectionSettingsEndpoint.TOGGLE_ENABLE(sectionName),
    );
    return res.data;
  },

  async createSection(payload: ICreateSectionRequest): Promise<IProductSection> {
    const res = await axiosClient.post<IProductSection>(
      ProductSectionSettingsEndpoint.CREATE_SECTION,
      payload,
    );
    return res.data;
  },
};
